function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4762 20.7699C16.4544 20.972 16.3986 21.0964 16.3515 21.1672H6.64844C6.60224 21.0973 6.54644 20.9738 6.52377 20.7699C6.46885 20.2534 5.99024 9.43396 5.81239 5.35214H17.1196C16.9914 8.66182 16.5346 20.2319 16.4762 20.7699ZM9.09214 3.02104C9.09214 2.74293 9.37547 2.51578 9.72419 2.51578H13.2741C13.6246 2.51578 13.9079 2.74293 13.9079 3.02104V3.52803H9.09214V3.02104ZM15.7901 3.52112V3.17564C15.7901 1.97597 14.8102 1 13.6054 1H9.39549C8.19067 1 7.21077 1.97597 7.21077 3.17564V3.52112H3V5.35215H3.96944L4.69477 21.3452C4.70872 21.4125 5.05221 23 6.44708 23H16.5521C17.9862 23 18.3113 21.3115 18.3157 21.2657C18.6757 17.2996 18.9974 5.35215 18.9974 5.35215H20V3.52112H15.7901ZM15.4205 6.48447H13.7527L13.3046 20.117H14.9732L15.4205 6.48447ZM10.6656 20.1165H12.3333V6.48401H10.6656V20.1165ZM8.02504 20.1172H9.69453L9.25166 6.60813L9.2473 6.48462H7.57868L8.02068 19.9928L8.02504 20.1172Z",
  fill: "#00796B"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Basket.253cc72c.svg";
export { SvgComponent as ReactComponent };